<template>
  <svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Info">
      <path
        d="M14 24.791C19.799 24.791 24.5 20.09 24.5 14.291C24.5 8.49203 19.799 3.79102 14 3.79102C8.20101 3.79102 3.5 8.49203 3.5 14.291C3.5 20.09 8.20101 24.791 14 24.791Z"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke="currentColor"
        style="fill: none !important"
      />
      <path
        d="M13.125 13.416C13.3571 13.416 13.5796 13.5082 13.7437 13.6723C13.9078 13.8364 14 14.059 14 14.291V18.666C14 18.8981 14.0922 19.1206 14.2563 19.2847C14.4204 19.4488 14.6429 19.541 14.875 19.541"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke="currentColor"
        fill="currentColor"
      />
      <path
        d="M13.5625 10.791C14.2874 10.791 14.875 10.2034 14.875 9.47852C14.875 8.75364 14.2874 8.16602 13.5625 8.16602C12.8376 8.16602 12.25 8.75364 12.25 9.47852C12.25 10.2034 12.8376 10.791 13.5625 10.791Z"
      />
    </g>
  </svg>
</template>
